export default function WebEvaPrivacy() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8 md:p-16 transition-colors duration-300">
      <h1 className="text-4xl font-bold mb-6 text-[#A8720E]">
        Privacy Policy – WebEva
      </h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        At <strong>WebEva</strong>, your privacy is important to us. This Privacy
        Policy explains how we collect, use, store, and protect your information
        when you use our mobile application.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        📱 Information We Collect
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-3xl">
        <li>
          <strong>Account Information:</strong> If you create an account, we may
          collect details such as your name, email address, or phone number.
        </li>
        <li>
          <strong>App Content & Preferences:</strong> Data you enter in the app
          and your app settings or preferences.
        </li>
        <li>
          <strong>Usage Data:</strong> App interactions and basic usage events
          collected via analytics to improve app performance and features.
        </li>
        <li>
          <strong>Advertising Identifiers:</strong> Device identifiers and
          ad-related data used for serving and measuring ads.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        ☁️ How We Store Your Data
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        Your data is securely stored on our servers using trusted cloud
        services. We implement appropriate security measures to protect your
        information from unauthorized access, loss, or misuse.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">📊 Analytics</h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        WebEva uses analytics tools to understand how users interact with the
        app. This helps us improve stability, performance, and user experience.
        Analytics data is collected in an aggregated and non-personal manner
        whenever possible.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">📢 Advertisements</h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        WebEva displays ads using <strong>Google AdMob</strong>. AdMob may collect
        device identifiers, approximate location, and interaction data to
        provide and measure ads. We do not sell your personal data, and ad data
        is processed according to Google&apos;s policies.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        🗑️ Account & Data Deletion
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-4 max-w-3xl">
        You have full control over your data. You may request permanent deletion
        of your WebEva account and all associated data at any time.
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-4">
        To request account deletion, please email us at:
      </p>

      <p className="text-lg font-semibold text-[#A8720E] mb-4">
        📩{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="underline text-[#0F6BBF] hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        Please contact us using the <strong>same email or phone number</strong>{" "}
        associated with your WebEva account. Once verified, your account and all
        related data will be permanently deleted within{" "}
        <strong>7 business days</strong>.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">🔐 Data Retention</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-3xl">
        After account deletion, all personally identifiable information is
        removed from our systems. Some anonymized or aggregated data may be
        retained for legal, security, or performance analysis purposes, but it
        cannot be used to identify you.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">🛡️ Contact Us</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-3xl">
        If you have any questions about this Privacy Policy, data usage, or
        account management, feel free to reach out to us at{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="text-[#0F6BBF] underline hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">
        Last updated: December 18, 2025
      </p>
    </div>
  );
}
